import React from "react";

import { AW23 } from "../../../../js/database/database-aw23-eshop.js";

import ProductsContainer from "../../../../components/containers/ProductsContainer.js";
import { SwiperSlide } from "swiper/react";

const ChainlockBikerPantsAW23 = () => {
  return (
    <ProductsContainer
      pageTitle={AW23.pants.ChainlockBikerPantsAW23.itemName}
      name={AW23.pants.ChainlockBikerPantsAW23.itemName}
      price={AW23.pants.ChainlockBikerPantsAW23.itemPrice}
      fabric={AW23.pants.ChainlockBikerPantsAW23.itemFabric}
      src={AW23.pants.ChainlockBikerPantsAW23.sizeChart}
      divId={AW23.pants.ChainlockBikerPantsAW23.shopifyDivId}
      mainId={AW23.pants.ChainlockBikerPantsAW23.shopifyId}
      buttonShouldHide={true}
    >
      {React.Children.toArray(
        AW23.pants.ChainlockBikerPantsAW23.pictures.map(({ srcJpeg }) => (
          <SwiperSlide>
            <img
              src={srcJpeg}
              alt={AW23.pants.ChainlockBikerPantsAW23.itemName}
              width={AW23.imgWidth}
              height={AW23.imgHeight}
              loading={AW23.loading}
            />
          </SwiperSlide>
        ))
      )}
    </ProductsContainer>
  );
};

export default ChainlockBikerPantsAW23;
